import { Component } from 'react';

import withSelectField from '../hoc/withSelectField';

import EmailChipInput from './EmailChipInput';

class EmailChipField extends Component {
    render() {
        const { form, field } = this.props;

        return (
            <EmailChipInput
                {...this.props}
                value={field.value}
                onChange={option => this.props.handleChange(option, form, field)}
                onBlur={() => this.props.handleBlur(form, field)}
            />
        );
    }
}

export default withSelectField(EmailChipField);
